export const enum AuthClientTypes {
  General = 'General Auth Client',
  Social = 'Social Auth Client',
}
